module.exports = __webpack_public_path__ + "img/6.855f0a64.png";